import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà donné son consentement
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Petit délai pour une meilleure UX
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    closeBanner();
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    closeBanner();
  };

  const closeBanner = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-300 ${
        isClosing ? 'translate-y-full opacity-0' : 'translate-y-0 opacity-100'
      }`}
    >
      <div className="bg-black/95 backdrop-blur-sm border-t border-gold/30 shadow-2xl">
        <div className="container mx-auto px-4 py-6 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            {/* Icône et Texte */}
            <div className="flex items-start gap-4 flex-1">
              <div className="flex-shrink-0 mt-1">
                <Cookie className="h-6 w-6 text-gold" />
              </div>
              <div className="flex-1">
                <h3 className="text-white font-semibold text-base mb-2">
                  🍪 Nous utilisons des cookies
                </h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Nous utilisons des cookies essentiels pour assurer le bon fonctionnement de notre site et améliorer votre expérience. 
                  En cliquant sur "Accepter", vous consentez à l'utilisation de ces cookies conformément à notre{' '}
                  <a
                    href="/privacy-policy"
                    className="text-gold hover:text-gold/80 underline transition-colors"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Politique de Confidentialité
                  </a>
                  .
                </p>
              </div>
            </div>

            {/* Boutons d'action */}
            <div className="flex items-center gap-3 w-full sm:w-auto">
              <button
                onClick={handleDecline}
                className="flex-1 sm:flex-none px-6 py-2.5 text-sm font-medium text-gray-300 hover:text-white border border-gray-600 hover:border-gray-500 rounded-lg transition-all duration-200 hover:bg-gray-800/50"
                aria-label="Refuser les cookies"
              >
                Refuser
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 sm:flex-none px-6 py-2.5 text-sm font-semibold text-black bg-gold hover:bg-gold/90 rounded-lg transition-all duration-200 shadow-lg hover:shadow-gold/20"
                aria-label="Accepter les cookies"
              >
                Accepter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
